export class Error {
  id: string;
  affectedUser: string;
  attemptedAction: string;
  capturedTime: string;
  error: any;
}
